<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bUxY7n/tc-custom/9781591811909.jpg?1702599090782" alt="This image is the cover for the book Back in Charge!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Back in Charge!
      </h1>
      <p class="bookDescription body article font2">
        <p>Most of us feel challenged in some area of life - our careers, our health, our relationships. We are being thwarted by the hardwiring of our brains. Adrianne Ahern's techniques train the brain to support optimal health, success, and well-being. These techniques can help you:Increase focus, creativity, and eagerness; Meet life's challenges with confidence and calm; Positively and effectively respond to change; Reduce negative impacts of a stressful life; Experience more energy and joy</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrianne Ahern
      </h2>
      
      <p class="authorDescription body article">drianne Ahern has a PhD in Clinical Psychology from the California School of Professional Psychology, with specializations in Counseling and Clinical Psychology from the University of San Francisco and the California School of Professional Psychology. She works with individuals and businesses to help focus their performance and gain the competitive edge. Drawing on more than fifteen years of clinical work, organizational consulting – including six years at the prestigious Scripps Hospital in La Jolla, CA – and her own spiritual practice, Dr. Ahern has developed unique tools for her clients to use. These techniques bridge the disciplines of psychology, neurophysiology, and natural healing, and use meditative breath work to heal gaps between the mind, heart, and body.  She is the author of Snap Out of it NOW!, a guide for those who feel out of synch with their true essence. She communicates her methods for training your brain for peak performance through speaking engagements, workshops, her private practice, and her CDs. She has worked with hundreds of clients who have benefited from her simple yet profound practices.  An avid athlete in her own right, Adrianne loves to ski and golf, and surfs when she can. She and her husband split their time between Reno, Nevada, and La Jolla, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sentient Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4bf7bf3b